module.exports = __webpack_public_path__ + "img/dd2bb40.png";